<button type="button"  hidden="true" class="btn btn-primary" data-bs-toggle="modal" [attr.data-bs-target]="'#'+idOpen" [id]="idButton"></button>
<div #modalComponent class="modal fade path" data-bs-backdrop="static" data-bs-keyboard="false" [id]="idOpen" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog {{ classModal }}" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ titulo }}</h5>
        <!-- <button type="button" [id]="idClose" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button> -->
        <button type="button" #closebutton [id]="idClose" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="emitClose()"></button>
      </div>
      <div class="modal-body">
        <ng-container *ngTemplateOutlet="innTemplate">
          <ng-template #innTemplate>

          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- Button trigger modal -->
<!-- <button id="pruebaModal" type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Launch demo modal
</button> -->

<!-- Modal -->
<!-- <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        ...
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>  -->
